var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-img',{attrs:{"src":_vm.picture}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }